import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { GlobalVariable } from 'src/globals';

@Injectable({
  providedIn: 'root'
})
export class TitleWrapperService {
  constructor(private titleService: Title) {     
  }

  public SetTitle(title: string = null, overwrite: boolean = false) {
    let fullTitle = GlobalVariable.PAGE_TITLE_BASE;
    if(title != null) fullTitle += ' - ' + title;
    this.titleService.setTitle(overwrite ? title : fullTitle);
  }
}
